"use client"
import React from 'react'
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';

const Specialcells = () => {
    const {language}=useTheme()
    //  const [page, setPage] = useState(1);
    const { data: list, loading, error } = useFetch(
        "/website/wings-special-cells",
        // { page, limit: 5 }, // pass page & limit here
        []
    );


    return (
        <>
            <div className='row'>
                <div className='col'>
                    <div className='directorate-main'>
                        <h4>{language=="en"?"SPECIAL CELLS":"പ്രത്യേക സെല്ലുകൾ"}</h4>
                        <p>{language=="en"?"There are three Special Cells located at Thiruvananthapuram, Ernakulam and Kozhikkode, have statewide jurisdiction. The Special Cells are generally entrusted with the investigation of Vigilance Cases relating to the amassment of disproportionate assets or the Confidential Verification of information pertaining to it. The Superintendent of Police, who heads the Cell is assisted by two Deputy Superintendents of Police and other officers":"തിരുവനന്തപുരം, എറണാകുളം, കോഴിക്കോട് എന്നിവിടങ്ങളിലായി മൂന്ന് പ്രത്യേക സെല്ലുകൾ പ്രവർത്തിക്കുന്നുണ്ട്, ഇവയ്ക്ക് സംസ്ഥാനവ്യാപകമായി അധികാരപരിധിയുണ്ട്. അനധികൃത സ്വത്തു സമ്പാദനവുമായി ബന്ധപ്പെട്ട വിജിലൻസ് കേസുകളുടെ അന്വേഷണമോ അതുമായി ബന്ധപ്പെട്ട വിവരങ്ങളുടെ രഹസ്യ പരിശോധനയോ ആണ് സാധാരണയായി പ്രത്യേക സെല്ലുകളെ ഏൽപ്പിച്ചിരിക്കുന്നത്. സെല്ലിന്റെ തലവനായ പോലീസ് സൂപ്രണ്ടിനെ സഹായിക്കാൻ രണ്ട് ഡെപ്യൂട്ടി പോലീസ് സൂപ്രണ്ടുമാരും മറ്റ് ഉദ്യോഗസ്ഥരും പ്രവർത്തിക്കുന്നു."}</p>
                    </div>
                </div>
            </div>
            <div className='row g-3 g-lg-4 mt-1'>
                {list?.length > 0 ? (
                    <>
                        {list?.map((item, index) => (
                            <>
                                <div key={index} className='col-md-6'>
                                    <div className='mision-card h-100'>
                                        <h4>{item?.name}</h4>
                                        <p>{item?.details}</p>
                                        <div className='ph-email'>
                                            <p> <IoCall style={{ color: "#ff9500" }} />  {item?.phone}</p>
                                            <a style={{ color: "#ccc" }} href={`mailto:${item?.email}`} className='mx-0 mx-lg-3'> <MdEmail style={{ color: "#ff9500" }} /> {item?.email}</a>
                                        </div>
                                    </div>
                                </div>

                            </>
                        ))}
                    </>
                ) : null}

            </div>
        </>
    )
}

export default Specialcells
